var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconGalaxy = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 83,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 161 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 132.406,
    cy: 9.58552,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5498
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.188,
    cy: 23.7347,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.254309
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.188,
    cy: 48.7347,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.254309
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.6761,
    cy: 66.5725,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.254309
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1878,
    cy: 28.9378,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.254309
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.18778,
    cy: 23.178,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.254309
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.93,
    cy: 59.1077,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.254309
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.094,
    cy: 38.7347,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.254309
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.188,
    cy: 47.9378,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.254309
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.094,
    cy: 17.7347,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.254309
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.094,
    cy: 9.73465,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.254309
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.48787,
    cy: 69.6656,
    r: 0.810623,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5498
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.098,
    cy: 36.8323,
    r: 1.99438,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.62125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.332,
    cy: 64.9573,
    r: 1.77561,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.62125
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.3438 19.6086C81.5285 20.7489 84.5025 22.2142 87.4285 24.11C96.0327 29.5423 105.553 42.0871 99.0242 52.1638C97.4443 54.6021 94.7266 56.3032 91.6461 56.9613C86.5564 58.0487 80.1195 56.763 74.2676 52.9714C69.7161 50.0224 66.4376 45.821 65.5219 41.535C64.9496 38.8563 65.4007 36.379 66.6359 34.2944C69.6136 29.8769 76.8359 29.5943 83.1468 33.5679C86.2067 35.4351 88.3668 38.3348 88.9677 41.1475C90.4433 48.0539 82.9112 50.0969 77.7888 46.778C75.4613 45.27 74.0499 40.8201 77.6493 40.005",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6658 67.967C56.9373 61.0157 49.3672 51.1489 47.2497 41.2375C45.7556 34.2444 46.8837 29.6914 49.6988 25.1685C53.4137 19.6131 60.4941 16.6999 69.2366 17.6331",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1415 66.5852C86.1585 66.6766 78.6317 64.2232 71.8331 59.9336C64.872 55.5387 59.9497 48.8875 58.5761 42.4585C57.6025 37.9016 58.3416 34.8057 60.2374 31.8798C64.4503 25.3777 75.5659 24.9635 84.994 31.0722C89.5455 34.0212 92.824 38.2226 93.7397 42.5086C94.312 45.1874 93.8609 47.6646 92.6257 49.7492C89.648 54.1667 82.4257 54.4493 76.1148 50.4757C73.0549 48.6085 70.8948 45.7088 70.2939 42.8961C68.7407 35.6263 77.1556 34.0713 82.2831 37.3935C85.7941 39.474 84.5996 43.1671 80.5557 43.932",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.745 62.5672C104.577 61.4019 106.73 59.6814 108.205 57.4056C110.733 53.5044 111.396 48.741 110.251 43.3835C108.305 34.2758 101.117 24.8874 91.0391 18.3574",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 83,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 161 83",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 132.406,
    cy: 9.58552,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.188,
    cy: 23.7347,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.188,
    cy: 48.7347,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.6761,
    cy: 66.5725,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.1878,
    cy: 28.9378,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.18778,
    cy: 23.178,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.93,
    cy: 59.1077,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.094,
    cy: 38.7347,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.188,
    cy: 47.9378,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.094,
    cy: 17.7347,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.094,
    cy: 9.73465,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.48787,
    cy: 69.6656,
    r: 0.810623,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.098,
    cy: 36.8323,
    r: 1.99438,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.332,
    cy: 64.9573,
    r: 1.77561,
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.3438 19.6086C81.5285 20.7489 84.5025 22.2142 87.4285 24.11C96.0327 29.5423 105.553 42.0871 99.0242 52.1638C97.4443 54.6021 94.7266 56.3032 91.6461 56.9613C86.5564 58.0487 80.1195 56.763 74.2676 52.9714C69.7161 50.0224 66.4376 45.821 65.5219 41.535C64.9496 38.8563 65.4007 36.379 66.6359 34.2944C69.6136 29.8769 76.8359 29.5943 83.1468 33.5679C86.2067 35.4351 88.3668 38.3348 88.9677 41.1475C90.4433 48.0539 82.9112 50.0969 77.7888 46.778C75.4613 45.27 74.0499 40.8201 77.6493 40.005",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6658 67.967C56.9373 61.0157 49.3672 51.1489 47.2497 41.2375C45.7556 34.2444 46.8837 29.6914 49.6988 25.1685C53.4137 19.6131 60.4941 16.6999 69.2366 17.6331",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1415 66.5852C86.1585 66.6766 78.6317 64.2232 71.8331 59.9336C64.872 55.5387 59.9497 48.8875 58.5761 42.4585C57.6025 37.9016 58.3416 34.8057 60.2374 31.8798C64.4503 25.3777 75.5659 24.9635 84.994 31.0722C89.5455 34.0212 92.824 38.2226 93.7397 42.5086C94.312 45.1874 93.8609 47.6646 92.6257 49.7492C89.648 54.1667 82.4257 54.4493 76.1148 50.4757C73.0549 48.6085 70.8948 45.7088 70.2939 42.8961C68.7407 35.6263 77.1556 34.0713 82.2831 37.3935C85.7941 39.474 84.5996 43.1671 80.5557 43.932",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.745 62.5672C104.577 61.4019 106.73 59.6814 108.205 57.4056C110.733 53.5044 111.396 48.741 110.251 43.3835C108.305 34.2758 101.117 24.8874 91.0391 18.3574",
    stroke: stroke,
    strokeWidth: weight === "normal" ? 1.5 : 1,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))));
});
export default SvgIconGalaxy;
export const raw = __webpack_public_path__ + "static/media/icon-galaxy.f28b17824795bbbe0f197acb7bf2ae05.svg";